module.exports = "https://trybtryb-legacy.web.app/img/wallet.f2b62f57.svg";